module.exports = __webpack_public_path__ + "img/fontello.2be8144.svg";